/**
 * Parses a string to a number by removing non-digit characters.
 *
 * @function
 * @param {string} valueString - The string value to parse.
 * @returns {number} The parsed number value.
 */
export const parseToNumber = (valueString: string) => Number(valueString.replace(/^\D+$/, ''));
